// IMPORT REACT
import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef
} from 'react'

// IMPORT UI COMPONENTS
import { useNavigate, useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { GetBillingReport, GetBillingTokenDetail } from '../../services/TokenService';
import { PdfViewer } from '../../components/PdfViewer';
import { PreferencesContext } from '../../PreferenceContext';
import { AlertType } from '../../services/models/AlertType';
import { EncryptDecryptService } from '../../services/common/EncryptionService';

interface BranchDetails {
  billingId: number;
  consumerId: number;
  organizationId: number;
  branchId: number;
  departmentId: number;
  specialityId: number;
  patientId: number;
}

const BillingReport = () => {
  const initialBranchDetails: BranchDetails = {
    billingId: 0,
    consumerId: 0,
    organizationId: 0,
    branchId: 0,
    departmentId: 0,
    specialityId: 0,
    patientId: 0,
  };

  const edService = new EncryptDecryptService();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [openInvoice, setOpeninvoice] = useState(true);
  const [invoiceTitle, setInvoiceTitle] = useState("");
  const [itemData, setItemData] = useState<any>(null);
  const [billingPrintReportData, setBillingPrintReportData] = useState<string>('');

  const [branchDetails, setBranchDetails] = useState<BranchDetails>(initialBranchDetails);
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const navigate = useNavigate();

  // Getting Seach Paramms for Pagination
  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }

  // GETTTING PARAMS
  let urlParams = useQuery();
  let token = urlParams.get("t");
  let currentToken: string = '';
  let billingId = urlParams.get("q");
  let curOpdId = 0;

  if (billingId !== null && billingId !== undefined) {
    let decId = edService.decrypt(billingId);
    if (
      decId !== "" &&
      decId !== null &&
      decId !== undefined
    ) {
      curOpdId = +decId;
    }
  }
  if (token !== null && token !== undefined) {
    currentToken = token;
  }

  const getBillingTokenDetail = async () => {
    try {
      let tokenData: any = null;
      const params = new URLSearchParams();
      params.append("token", token || "");

      const result: any = await GetBillingTokenDetail(params, currentToken);

      if (result?.data?.data) {
        const data = result.data.data;

        tokenData = {
          billingId: data.billingId ?? 0,
          consumerId: data.consumerId ?? 0,
          organizationId: data.organizationId ?? 0,
          branchId: data.branchId ?? 0,
          departmentId: data.departmentId ?? 0,
          specialityId: data.specialityId ?? 0,
        };

        setBranchDetails(tokenData);
      }
      return tokenData;
    } catch (e) {
      console.error("Error fetching branch details:", e);
    }
  };

  async function openBillingPopup(item: any, reportName: string) {
    try {
      setIsLoading(true);
      let params = new URLSearchParams();
      params.append("reportName", reportName);
      params.append("reportType", "pdf");
      params.append("consumerId", item?.consumerId.toString());
      params.append("branchId", item?.branchId.toString());
      params.append("organizationId", item?.organizationId.toString());
      params.append("billingId", item?.billingId?.toString());
      params.append("includeHeader", "true");
      params.append("includeFooter", "true");

      const result: any = await GetBillingReport(params, currentToken);
      if (result && result.data && result.data.data) {
        let fileData = result.data.data.fileData;
        const linkSource = `data:application/pdf;base64,${fileData}`;
        setBillingPrintReportData(linkSource);
        setInvoiceTitle(item?.billingNumber || "Billing Invoice");
        setItemData(item);
        setOpeninvoice(true);
      }
      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  // FETCH DATA
  const fetchData = async () => {
    try {
      const tokenData = await getBillingTokenDetail();
      if (tokenData?.billingId || 0) {
        await openBillingPopup(tokenData, "BillingInvoiceA4");
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  const handleCloseInvoice = () => {
    setOpeninvoice(false);
    // Optionally navigate back or just close
  };

  // USE EFFECTS
  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, [billingId]);

  return (
    <>
      {openInvoice && (
        <PdfViewer
          openInvoice={openInvoice}
          //handleCloseInvoice={handleCloseInvoice}
          invoiceHtmlTitle={"Billing Invoice"}
          invoiceHtml={billingPrintReportData}
          invoiceTitle={invoiceTitle}
          itemData={itemData}
          isLoading={isLoading}
          
        />
      )}
    </>
  )
}

export default BillingReport
